// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e1b5099e","280":"9974baef","428":"1759ace1","437":"577f93f2","442":"0b473093","447":"96a90951","602":"95935677","609":"f513e4eb","659":"60fed4b9","726":"63d902db","968":"c22ebd82"}[chunkId] + ".chunk.js";
};